import React, { useEffect } from 'react';
import { Table, Badge, OverlayTrigger, Tooltip, Row, Col, Card, Form, Button } from "react-bootstrap";
import { useForm, Controller } from 'react-hook-form';
import Select from "react-select";
import API from "../../../services/axiosInstance";
import { FormLoader, useFormLoader } from "../../common_modules/loader";
import { useNavigate, useParams, Link } from 'react-router-dom';
import Permission from '../../security/permission';
import { AUTH_CODE } from '../../security/authCodes';
// prevent multiple clicks
// import useSubmitPrevent from "../../utils/SubmitPrevent";
import usePreventMultiClick from '../../utils/SubmitPrevent';
const adSizes = [
    { value: "None", label: "None" },
    { value: "-1*-1", label: "-1x-1" },
    { value: "120*20", label: "120x20" },
    { value: "168*28", label: "168x28" },
    { value: "216*36", label: "216x36" },
    { value: "300*250", label: "300x250" },
    { value: "300*50", label: "300x50" },
    { value: "320*50", label: "320x50" },
    { value: "970*250", label: "970x250" },
    { value: "300*600", label: "300x600" },
    { value: "300*1050", label: "300x1050" },
    { value: "970*90", label: "970x90" },
    { value: "180*150", label: "180x150" },
    { value: "160*600", label: "160x600" },
    { value: "728*90", label: "728x90" },
    { value: "120*60", label: "120x60" },
    { value: "88*31", label: "88x31" },
    { value: "550*480", label: "550x480" },
    { value: "0*0", label: "0x0" },
    { value: "320*480", label: "320x480" },
    { value: "480*320", label: "480x320" },
    { value: "120*600", label: "120x600" },
    { value: "468*60", label: "468x60" },
    { value: "768*1024", label: "768x1024" },
    { value: "1024*768", label: "1024x768" },
    { value: "480*80", label: "480x80" },
    { value: "800*480", label: "800x480" },
    { value: "480*800", label: "480x800" },
    { value: "336*280", label: "336x280" },
    { value: "640*360", label: "640x360" },
    { value: "1920*1080", label: "1920x1080" },
    { value: "1280*720", label: "1280x720" },
    { value: "492*412", label: "492x412" },
    { value: "640*100", label: "640x100" },
    { value: "300*100", label: "300x100" },
    { value: "320*100", label: "320x100" },
    { value: "300*400", label: "300x400" },
    { value: "320*240", label: "320x240" },
    { value: "320*320", label: "320x320" },
    { value: "200*200", label: "200x200" },
    { value: "250*250", label: "250x250" },
    { value: "320*150", label: "320x150" },
    { value: "800*1280", label: "800x1280" },
    { value: "320*568", label: "320x568" },
    { value: "240*400", label: "240x400" },
    { value: "250*360", label: "250x360" },
    { value: "580*400", label: "580x400" },
    { value: "930*180", label: "930x180" },
    { value: "980*120", label: "980x120" },
    { value: "640*960", label: "640x960" },
    { value: "720*1280", label: "720x1280" },
    { value: "1440*2960", label: "1440x2960" },
    { value: "1440*2560", label: "1440x2560" },
    { value: "1080*1920", label: "1080x1920" },
    { value: "1280*800", label: "1280x800" },
    { value: "480*854", label: "480x854" },
    { value: "540*960", label: "540x960" },
    { value: "1440*2880", label: "1440x2880" },
    { value: "1080*2160", label: "1080x2160" },
    { value: "1920*1200", label: "1920x1200" },
    { value: "1024*600", label: "1024x600" },
    { value: "720*1440", label: "720x1440" },
    { value: "2048*1536", label: "2048x1536" },
    { value: "1440*3120", label: "1440x3120" },
    { value: "1080*2280", label: "1080x2280" },
    { value: "2560*1600", label: "2560x1600" },
    { value: "720*1480", label: "720x1480" },
    { value: "480*960", label: "480x960" },
    { value: "1080*2340", label: "1080x2340" },
    { value: "1080*2180", label: "1080x2180" },
    { value: "1366*768", label: "1366x768" },
    { value: "1080*2220", label: "1080x2220" },
    { value: "1312*2560", label: "1312x2560" },
    { value: "1900*1200", label: "1900x1200" },
    { value: "720*1520", label: "720x1520" },
    { value: "1400*2392", label: "1400x2392" },
    { value: "1600*2560", label: "1600x2560" },
    { value: "720*1080", label: "720x1080" },
    { value: "1080*2244", label: "1080x2244" },
    { value: "720*960", label: "720x960" },
    { value: "2160*3840", label: "2160x3840" },
    { value: "1080*1620", label: "1080x1620" },
    { value: "2160*1440", label: "2160x1440" },
    { value: "750*1334", label: "750x1334" },
    { value: "1080*2246", label: "1080x2246" },
    { value: "1440*900", label: "1440x900" },
    { value: "400*800", label: "400x800" },
    { value: "2560*1800", label: "2560x1800" },
    { value: "1280*1920", label: "1280x1920" },
    { value: "480*850", label: "480x850" },
    { value: "768*1280", label: "768x1280" },
    { value: "240*320", label: "240x320" },
    { value: "845*140", label: "845x140" },
    { value: "970*66", label: "970x66" },
    { value: "996*372", label: "996x372" },
    { value: "1280*400", label: "1280x400" },
    { value: "400*300", label: "400x300" },
    { value: "360*640", label: "360x640" },
    { value: "360*240", label: "360x240" },
    { value: "420*70", label: "420x70" },
    { value: "396*266", label: "396x266" },
    { value: "382*260", label: "382x260" },
    { value: "595*595", label: "595x595" },
    { value: "595*596", label: "595x596" },
    { value: "970*50", label: "970x50" },
    { value: "310*260", label: "310x260" },
    { value: "300*180", label: "300x180" },
    { value: "300*168", label: "300x168" },
    { value: "300*250", label: "300x250" },
    { value: "300*300", label: "300x300" },
];

const InstreamAdForm = ({
    mode = 'add',
    defaultValues = {},
    publisherName,
}) => {

    const location = useParams();
    const accId = location?.id;
    const accGuid = location?.guid;
    // const adId = location?.adId;
    const navigate = useNavigate();
    const { control, handleSubmit, register, reset, formState: { errors } } = useForm({});
    const { isLoading, startLoading, stopLoading } = useFormLoader(); // custom hook loader
    // const submittingRef  = useSubmitPrevent();
    const { btnClicked, setBtnClicked } = usePreventMultiClick();

        // Common trim function
    const trimPayload = (payload) => {
        return Object.fromEntries(
            Object.entries(payload).map(([key, value]) => [
                key,
                typeof value === "string" ? value.trim() : value
            ])
        );
    };

    const onSubmit = async (data) => {
        if(btnClicked) return;
        setBtnClicked(true);
        // if (submittingRef.current) return;
        // submittingRef.current = true;
        startLoading();
        const payload = {
            id: mode === "edit" ? data?.id : 0,
            accountId: Number(accId),
            accountGuid: accGuid,
            title: data?.title,
            generationType: data?.generation_type,
            status: Number(data?.status),
            adFormat: data?.ad_Format,
            adSize: data?.adSizes.value,
            vastTagUrl: data?.vast_tag_url,
            remarks: data?.remarks,
            isPrimary: Number(data?.is_primary),
        }

        const cleanedPayload = trimPayload(payload);

        try {
            const apiCall =
                mode === "add"
                    ? API.post("/publisher/instream/ad/setup/save", cleanedPayload)
                    : API.put('/publisher/instream/ad/setup/update', cleanedPayload);
            const response = await apiCall;
            if (response?.data?.status === "Success") {
                alert(response?.data?.message || "Success");
                navigate(`/publisher/instream-ad-list/${accId}/${accGuid}`);
            } else {
                alert(response?.data?.message || "Failed");
            }
        } catch (error) {
            alert(error?.response?.data?.message || "Something went wrong!");
        } finally {
            // submittingRef.current = false;
            setBtnClicked(false);
            stopLoading();
        }
    }

    useEffect(() => {
        console.log(defaultValues);
        if (mode === "edit" && defaultValues) {
            reset(defaultValues);
        }
    }, [mode, defaultValues]);

    return (
        <FormLoader isLoading={isLoading} text={"Loading..."}>
            <div className="breadCrumb gradient-bg">
                <Link to={'/dashboard'}><span>Home</span></Link>
                <Permission code={AUTH_CODE.accounts.publisherListing}>
                    <Link to={'/active-publisher'}><span>Publisher</span></Link>
                </Permission>
                <span>{publisherName}</span>
                <Link to={`/publisher/instream-ad-list/${accId}/${accGuid}`}><span>Manage Instream Ad</span></Link>
                <span>{mode === "edit" ? "Update" : "Create"}</span>
                {/* {mode === "edit" ? <span>{accId}</span> : ''} */}
            </div>
            <Card className="p-3 instreamRows">
                <span className="text-danger" style={{ fontSize: "12px" }}>All fields marked with * are mandatory</span>
                <h6 className="title mb-5">Ad Setup Form</h6>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Card className="p-3">
                        {/* Title */}
                        <Row>
                            <Col md={3}>
                                <label>Title <span className="text-danger">*</span> </label>
                            </Col>
                            <Col md={5}>
                                <Form.Control type="text" placeholder="Enter here..." 
                                // {...register("title", { required: "Title is required" })} 
                                {...register("title", {
                                    setValueAs: (value) =>
                                        typeof value === "string" ? value.trim() : value,
                                    required: "Title is required"
                                })}
                                />
                                {errors.title && <p className="text-danger">{errors.title.message}</p>}
                            </Col>
                        </Row>
                        {/* Generation Type */}
                        <Row>
                            <Col md={3}>
                                <label>Generation Type</label>
                            </Col>
                            <Col md={5}>
                                <select className="form-select" {...register("generation_type")}>
                                    <option value="ADX">ADX</option>
                                </select>
                            </Col>
                        </Row>
                        {/* Generation Type */}
                        <Row>
                            <Col md={3}>
                                <label>Status</label>
                            </Col>
                            <Col md={5}>
                                <select className="form-select" {...register("status")}>
                                    <option value="1">Active</option>
                                    <option value="5" >Pending</option>
                                </select>
                            </Col>
                        </Row>
                        {/* Is Primary */}
                        <Row>
                            <Col md={3}>
                                <label>Is Primary</label>
                            </Col>
                            <Col md={5}>
                                <select className="form-select" {...register("is_primary")}>
                                    <option value="0" >No</option>
                                    <option value="1">Yes</option>
                                </select>
                            </Col>
                        </Row>
                        {/* Ad Format */}
                        <Row>
                            <Col md={3}>
                                <label>Ad Format <span className="text-danger">*</span></label>
                            </Col>
                            <Col md={5}>
                                <select className="form-select" {...register("ad_Format", { required: true })}>
                                    <option value="Video">Video Only</option>
                                    <option value="Video/Audio" >Video / Audio</option>
                                </select>
                            </Col>
                        </Row>
                        {/* Vast Tag Url */}
                        <Row>
                            <Col md={3}>
                                <label>Vast Tag Url <span className="text-danger">*</span></label>
                            </Col>
                            <Col md={5}>
                                <Form.Control as="textarea" rows={6} placeholder="Enter here..." 
                                // {...register("vast_tag_url", { required: "Vast Tag Url is required" })} 
                                {...register("vast_tag_url", {
                                    setValueAs: (value) =>
                                        typeof value === "string" ? value.trim() : value,
                                    required: "Vast Tag Url is required"
                                })}
                                />
                                {errors.vast_tag_url && <p className="text-danger">{errors.vast_tag_url.message}</p>}
                            </Col>
                        </Row>
                        {/* Ad Size */}
                        <Row>
                            <Col md={3}>
                                <label>Ad Size <span className="text-danger">*</span></label>
                            </Col>
                            <Col md={5}>
                                <Controller className="fieldFont" name="adSizes" control={control} rules={{ required: "Please select at least one ad size" }} render={({ field }) => (
                                    <Select className="fieldFont basic-multi-select" classNamePrefix="select" {...field} options={adSizes} isSearchable={true} placeholder="Please Select" />
                                )} />
                                {errors.adSizes && <p className="text-danger">{errors.adSizes.message}</p>}
                            </Col>
                        </Row>
                        {/* Remark */}
                        <Row>
                            <Col md={3}>
                                <label>Remarks</label>
                            </Col>
                            <Col md={5}>
                                <Form.Control as="textarea" rows={6} placeholder="Enter here..." minLength="6" maxLength="100" {...register("remarks")} />
                                <span className="text-secondary" style={{ fontSize: "12px" }}>Minimun 6 characters & Maximum 100 characters</span>
                            </Col>
                        </Row>
                    </Card>
                    <Button type="submit" variant="primary" disabled = {btnClicked} className="mt-3 submitBtn">{mode === "add" ? "Create" : "Update"}</Button>
                    <Button type="button" variant="secondary" className="mx-5 mt-3 cancelBtn" onClick={() => navigate(`/publisher/instream-ad-list/${accId}/${accGuid}`)}>Cancel</Button>
                </form>
            </Card>
        </FormLoader>
    )
}

export default InstreamAdForm;